


















import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

import DigitalCurrency20AnimatedCurrencyLabel from './digital-currency-20-animated-currency-label.vue'

import { projectVariables } from '../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-1-introduction'

@Component({
  components: {
    DigitalCurrency20AnimatedCurrencyLabel
  }
})
class AccountBalanceNumberWithIcon extends Vue {
  @Prop({ default: 0 }) currencyAmount?: number
  @Prop({ default: '' }) accountId?: string
  @Prop({ default: () => { return {} } }) cssClassObject?: any
  @Prop({ default: true }) showVerticalIncrementDecrementAnimation?: boolean
  @Prop({ default: true }) showIncrementDecrementAnimationSinceTimeUpdate?: boolean
  @Prop({ default: false }) showIncrementDecrementAnimationNumberOfTransactions?: boolean
  @Prop({ default: false }) showIncrementDecrementAnimationTransactionTextAbbreviated?: boolean

  digitalCurrencySymbolImageIconUrl: string = projectVariables.digitalCurrencySymbolImageIconUrl

}
export default AccountBalanceNumberWithIcon
